import { useState, useEffect } from 'react';
import { useMonitor, useAppDispatch, useLocalStorage } from './hooks';
import { InactivityModal } from '../modals/InactivityModal';
import { setAuthenticated } from '../features/application/appSlice';
import { setNotifications } from '../features/application/appSlice';

const SessionTimeout = () => {
  const [isOpen, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const [, setAuthExpiration] = useLocalStorage('authExpiration', 0);

  let timer1;
  useEffect(() => {
    const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

    for (let i in events) {
      window.addEventListener(events[i], handleClose);
    }

    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], handleClose);
      }
      clearTimeout(timer1);
    };
  }, [isOpen, timer1]);

  const handleWarn = () => {
    setOpen(true);
  };

  const handleTimeout = () => {
    setAuthExpiration(0);
    setOpen(false);
    dispatch(setAuthenticated(false));
    dispatch(setNotifications({ message: 'Logged out due to inactivity' }));
  };

  const handleClose = () => {
    setOpen(false);
  };

  useMonitor({
    timeout: 2 * 60 * 1000,
    warningTimeout: 10 * 60 * 1000,
    onWarn: handleWarn,
    onTimeout: handleTimeout,
  });
  return isOpen ? <InactivityModal show={isOpen} onHide={handleClose} /> : null;
};

export default SessionTimeout;
